import { REQUIRED } from '@atlassian/jira-issue-create-common-types/src/common/constants/index.tsx';

export const validateTimeTrackingField = (
	value?: string,
	// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
	isRequired: boolean,
): string | undefined => {
	if (isRequired) {
		if (value === '' || value === undefined) {
			return REQUIRED;
		}
	}
	return undefined;
};
